import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import TutorDashboard from "../components/Tutor/TutorDashboard/TutorDashboard";
import TutorMyCourse from "../components/Tutor/TutorMyCourse/TutorMyCourse";
import TutorAssignments from "../components/Tutor/TutorAssignments/TutorAssignments";
import TutorStudentDoubts from "../components/Tutor/TutorStudentDoubts/TutorStudentDoubts";
// import TutorAnnouncements from "../components/Tutor/TutorAnnouncements/TutorAnnouncements";
import TutorAnalytics from "../components/Tutor/TutorAnalytics/TutorAnalytics";
import TutorFeedback from "../components/Tutor/TutorFeedback/TutorFeedback";
import TutorNotifications from "../components/Tutor/TutorNotifications/TutorNotifications";
import TutorTutorial from "../components/Tutor/TutorTutorial/TutorTutorial";
import TutorProfile from "../components/Tutor/TutorProfile/TutorProfile";
import TutorSettings from "../components/Tutor/TutorSettings/TutorSettings";

import TutorRouteGuard from "../components/ProtectedRoute/TutorRouteGuard";
import NotFound from "../components/NotFound/NotFound";

const TutorRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />

      <Route
        path="dashboard"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorDashboard />
          </TutorRouteGuard>
        }
      />
      <Route
        path="my-courses"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorMyCourse />
          </TutorRouteGuard>
        }
      />
      <Route
        path="assignments"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorAssignments />
          </TutorRouteGuard>
        }
      />
      <Route
        path="student-doubts"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorStudentDoubts />
          </TutorRouteGuard>
        }
      />
      {/* <Route
        path="announcements"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorAnnouncements />
          </TutorRouteGuard>
        }
      /> */}
      <Route
        path="analytics"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorAnalytics />
          </TutorRouteGuard>
        }
      />
      <Route
        path="feedback"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorFeedback />
          </TutorRouteGuard>
        }
      />
      <Route
        path="notifications"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorNotifications />
          </TutorRouteGuard>
        }
      />
      <Route
        path="tutorial"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorTutorial />
          </TutorRouteGuard>
        }
      />
      <Route
        path="profile"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorProfile />
          </TutorRouteGuard>
        }
      />
      <Route
        path="settings"
        element={
          <TutorRouteGuard type="dashboard">
            <TutorSettings />
          </TutorRouteGuard>
        }
      />

      {/* Catch all wrong student routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default TutorRoutes;
